// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.downloads-plugin {
    font-family: sans-serif;
    min-width: 300px;
}

.downloads-plugin h4 {
    margin: 0 0 10px 0;
    border-bottom: 1px lightgrey solid;
}

.downloads-plugin .downloadStream {    
    margin-left: 5px;
}

.downloads-plugin .downloadStream ul {
    list-style: none;
    max-height: 500px;
    overflow: auto;
    padding: 0px;
    margin: 0 0 10px 10px;
}

.downloads-plugin .downloadStream .mimetype {
    color: lightcoral;
    margin-right: 10px;
}

.downloads-plugin .downloadStream .res {
    color: lightsalmon;
}

.downloads-plugin .downloadStream .transcript {
    color: coral;
}


.downloads-plugin a {
    color: lightsalmon;
}

.downloads-plugin a:hover {
    color: salmon;
}

`, "",{"version":3,"sources":["webpack://./src/css/DownloadsPlugin.css"],"names":[],"mappings":";AACA;IACI,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,kCAAkC;AACtC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;IACd,YAAY;IACZ,qBAAqB;AACzB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,YAAY;AAChB;;;AAGA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;AACjB","sourcesContent":["\n.downloads-plugin {\n    font-family: sans-serif;\n    min-width: 300px;\n}\n\n.downloads-plugin h4 {\n    margin: 0 0 10px 0;\n    border-bottom: 1px lightgrey solid;\n}\n\n.downloads-plugin .downloadStream {    \n    margin-left: 5px;\n}\n\n.downloads-plugin .downloadStream ul {\n    list-style: none;\n    max-height: 500px;\n    overflow: auto;\n    padding: 0px;\n    margin: 0 0 10px 10px;\n}\n\n.downloads-plugin .downloadStream .mimetype {\n    color: lightcoral;\n    margin-right: 10px;\n}\n\n.downloads-plugin .downloadStream .res {\n    color: lightsalmon;\n}\n\n.downloads-plugin .downloadStream .transcript {\n    color: coral;\n}\n\n\n.downloads-plugin a {\n    color: lightsalmon;\n}\n\n.downloads-plugin a:hover {\n    color: salmon;\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
